import styled from 'styled-components';

import Button from 'components/Button';
import { getButtonTheme } from 'components/Button/styled';

const prefix = ['components', 'datepicker'];

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 400px;
  max-width: 800px;
  padding: 24px;
`;

export const FiltersWrapper = styled.div`
  max-height: 600px;
  overflow: hidden auto;
  padding-bottom: 5px;
`;

export const Actions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 12px;
  width: 100%;
`;

const baseButtonProps = {
  size: 'md',
  type: 'button',
} as const;

export const CancelButton = styled(Button).attrs(() => ({
  ...baseButtonProps,
  variant: 'outlined',
}))`
  ${getButtonTheme([...prefix, 'controlButtons', 'cancelButton'])};
`;

export const ApplyButton = styled(Button).attrs(() => ({
  ...baseButtonProps,
  variant: 'primary',
}))`
  ${getButtonTheme([...prefix, 'controlButtons', 'applyButton'])};
`;
